import React, { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Box, Button, Stack, Typography, useTheme } from '@mui/material';

import { pxToRem } from '@/theme/typography';
import RefreshIcon from '@mui/icons-material/Refresh';
import CustomizedCircularProgress from '@/components/shared/customized-circular-progress';
import ImageBoxFuture from '../shared/image-box-future';
type OfferErrorBadgeProps = {
  title: ReactNode;
  actionTitle?: ReactNode;
  icon?: string;
  handleAction?: () => void;
  isLoading?: boolean;
};

const OfferErrorBadge: FC<OfferErrorBadgeProps> = ({
  title,
  icon,
  handleAction,
  isLoading,
  actionTitle,
}) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Stack
      spacing={1}
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      sx={{
        width: '100%',
        padding: pxToRem(15),
        marginLeft: 0,
        backgroundColor: theme.palette.lightGrey.main,
        borderRadius: '12px',
      }}
    >
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        {icon && (
          <ImageBoxFuture
            img={icon}
            title={intl.formatMessage({
              id: 'alt.offer_icon',
            })}
            objectFit='contain'
            sx={{
              width: '35px',
              height: '30px',
              mr: '4px',
              [theme.breakpoints.down('mediumDesktop')]: {
                mr: '8px',
              },
            }}
          />
        )}
        <Typography
          variant='subtitle2'
          sx={{
            fontWeight: 400,
            color: theme.palette.grey[60],
          }}
        >
          {title}
        </Typography>
      </Stack>
      {!isLoading ? (
        <Button onClick={handleAction} sx={{ color: theme.palette.primary.main }}>
          <RefreshIcon
            fontSize={'small'}
            sx={{ transform: 'rotate(310deg)' }}
            fontWeight={700}
          />
          <Typography
            variant='subtitle2'
            sx={{
              fontWeight: 700,
              color: theme.palette.primary.main,
            }}
          >
            {actionTitle}
          </Typography>
        </Button>
      ) : (
        <Box
          sx={{
            minWidth: '64px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CustomizedCircularProgress size={15} thickness={4} />
        </Box>
      )}
    </Stack>
  );
};

export default OfferErrorBadge;
